import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { Job } from 'entities/job'

export const Tagline = ({ tagline }: Pick<Job, 'tagline'>) => {
    return (
        <Flex>
            <Box
                flexShrink={0}
                width={'4px'}
                borderRadius={'4px'}
                backgroundColor={'secondary.500'}
                mr={'10px'}
            />
            <Text variant="bodyTextSmall" fontStyle="italic">
                {tagline}
            </Text>
        </Flex>
    )
}
